module.exports = __webpack_public_path__ + "static/content_3_3_eg-4a644170e4e6a16385b8b7a38779b463.png";